import { render, staticRenderFns } from "./createTestimonial.vue?vue&type=template&id=6251c412&"
import script from "./createTestimonial.vue?vue&type=script&lang=js&"
export * from "./createTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./createTestimonial.vue?vue&type=style&index=0&lang=scss&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports